import './FreePremiumMealsBanner.scss'
import { ReactComponent as FreePremiumMealIcon } from 'src/assets/svg/free-premium-meal.svg'
import { ReactComponent as CheckmarkIcon } from 'src/assets/svg/checkmark.svg'
import { CuiButton } from 'front-lib'
import {
  FreePremiumMealsBannerEnum,
  getFreePremiumMealsBannerText
} from '../utils'
import { useFreePremiumMeals } from '../useFreePremiumMeals'
import {
  trackFreePremiumMealsBannerButtonClicked,
  trackBannerViewed
} from 'src/utils/tracking'
import { useEffect } from 'react'

interface FreePremiumMealsBannerProps {
  status: FreePremiumMealsBannerEnum
  onButtonClick?: () => void
}

export const FreePremiumMealsBanner = ({
  status,
  onButtonClick
}: FreePremiumMealsBannerProps) => {
  const isClaimBanner = status === FreePremiumMealsBannerEnum.CLAIM
  const isConfirmedBanner = status === FreePremiumMealsBannerEnum.CONFIRMED
  const { freePremiumMealsQty } = useFreePremiumMeals()
  const bannerTexts = getFreePremiumMealsBannerText(status)

  const trackButtonClick = (btnText: string) => {
    trackFreePremiumMealsBannerButtonClicked(btnText)
    onButtonClick && onButtonClick()
  }

  const title =
    freePremiumMealsQty > 1 ? bannerTexts.titlePlural : bannerTexts.title

  const subtitle =
    freePremiumMealsQty > 1 ? bannerTexts.subtitlePlural : bannerTexts.subtitle

  const buttonText =
    freePremiumMealsQty > 1 ? bannerTexts.ctaPlural : bannerTexts.cta

  useEffect(() => {
    if (isClaimBanner) {
      trackBannerViewed('choose free premium meals')
    } else if (isConfirmedBanner) {
      trackBannerViewed('free premium meals selected')
    }
  }, [isClaimBanner, isConfirmedBanner])

  return (
    <div className="free-premium-meals-banner">
      <div className="free-premium-meals-banner-content">
        <div className="free-premium-meals-banner-header">
          <div className="free-premium-meals-banner-svg-container">
            <FreePremiumMealIcon />
            {isConfirmedBanner && (
              <CheckmarkIcon className="free-premium-meals-banner-svg-checkmark" />
            )}
          </div>
          <div className="free-premium-meals-banner-title-container">
            <span className="free-premium-meals-banner-title">{title}</span>
            <span className="free-premium-meals-banner-subtitle">
              {subtitle}
            </span>
            {isConfirmedBanner && (
              <span
                className="free-premium-meals-banner-see-meals"
                onClick={() => trackButtonClick(bannerTexts.ctaTracking)}>
                {buttonText}
              </span>
            )}
          </div>
        </div>
        {isClaimBanner && (
          <CuiButton
            onClick={() => trackButtonClick(bannerTexts.ctaTracking)}
            size="small"
            fill="outline"
            color="light">
            {buttonText}
          </CuiButton>
        )}
      </div>
    </div>
  )
}
